/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Spinner = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 120 120">
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="url(#a)"
          d="M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Zm0-10c27.614 0 50-22.386 50-50S87.614 10 60 10 10 32.386 10 60s22.386 50 50 50Z"
        />
        <path
          fill="#fff"
          d="M113.908 48.004a5 5 0 0 1 5.598 4.319c.329 2.546.494 5.11.494 7.677a5 5 0 0 1-10 0c0-2.14-.138-4.276-.411-6.398a5 5 0 0 1 4.319-5.598Z"
        />
      </g>
      <defs>
        <radialGradient id="a" cx={0} cy={0} r={1} gradientTransform="matrix(60 0 0 60 60 60)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset={0} stopColor="#3AE180" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" />
        </radialGradient>
      </defs>
    </BaseSvgIcon>
  )
}

export default Spinner
